export default __webpack_public_path__ + "static/media/flashlight.3f544467.png";